// extracted by mini-css-extract-plugin
export default {"dialog":"i4MTUUF","header":"kGN458Q","headerTop":"HMgls3D","headline":"RRNM3V2","main":"ktU57QV"};